import { calculateTableData } from "../../src/utils/calculationFunctions";

// Action types
export const SET_PROCESSPOINT_WINTER = " SET_PROCESSPOINT_WINTER";
export const ADD_PROCESSPOINT_WINTER = "ADD_PROCESSPOINT_WINTER";
export const ADD_HEATINGPROCESSPOINT_WINTER = "ADD_HEATINGPROCESSPOINT_WINTER";
export const ADD_COOLINGPROCESSPOINT_WINTER = "ADD_COOLINGPROCESSPOINT_WINTER";
export const ADD_MIXINGPROCESSPOINT_WINTER = "ADD_MIXINGPROCESSPOINT_WINTER";

export const UPDATE_PROCESSPOINT_WINTER = "UPDATE_PROCESSPOINT_WINTER";
export const UPDATE_INDOORPOINT_WINTER = "UPDATE_INDOORPOINT_WINTER";
export const UPDATE_OUTDOORPOINT_WINTER = "UPDATE_OUTDOORPOINT_WINTER";
export const GET_INDOORPOINT_WINTER = "GET_INDOORPOINT_WINTER";
export const GET_OUTDOORPOINT_WINTER = "GET_OUTDOORPOINT_WINTER";
export const GET_LASTPROCESSPOINT_WINTER = "GET_LASTPROCESSPOINT_WINTER";
export const GET_LASTTWOPROCESSPOINT_WINTER = "GET_LASTTWOPROCESSPOINT_WINTER";
export const GET_ARRAY_LENGHT_WINTER = "GET_ARRAY_LENGHT_WINTER";
export const GET_ARRAY_DATA_WINTER = "GET_ARRAY_DATA_WINTER";
export const ADD_NEW_WINTER_PROCESSPOINT = "ADD_NEW_WINTER_PROCESSPOINT";
export const ADD_OR_UPDATE_HEATINGPOINT_WINTER =
  "ADD_OR_UPDATE_HEATINGPOINT_WINTER";
export const ADD_OR_UPDATE_COOLINGPOINT_WINTER =
  "ADD_OR_UPDATE_COOLINGPOINT_WINTER";
export const ADD_OR_UPDATE_MIXINGPOINT_WINTER =
  "ADD_OR_UPDATE_MIXINGPOINT_WINTER";
export const ADD_OR_UPDATE_STEAMHUMIDITYPOINT_WINTER =
  "ADD_OR_UPDATE_STEAMHUMIDITYPOINT_WINTER";
export const CHANGE_OUTDOOR_POINT_WINTER = "CHANGE_OUTDOOR_POINT_WINTER";
export const CHANGE_INDOOR_POINT_WINTER = "CHANGE_INDOOR_POINT_WINTER";
export const ADD_DLL_EHA_POINT_WINTER = "ADD_DLL_EHA_POINT_WINTER";
export const ADD_DLL_SUP_POINT_WINTER = "ADD_DLL_SUP_POINT_WINTER";

export const ADD_HEATER_SUP_POINT = "ADD_HEATER_SUP_POINT";
export const ADD_HEATER_EHA_POINT = "ADD_HEATER_EHA_POINT";
export const SET_INITIAL_STATE = "SET_INITIAL_STATE";
export const CHANGE_WINTER_POINT_PROCESS = "CHANGE_WINTER_POINT_PROCESS";
export const DELETE_PROCESS_POINT = "DELETE_PROCESS_POINT";
export const UPDATE_AIRFLOW = "UPDATE_AIRFLOW";

// Create Redux action creators that return an action
/*export const setProcessPointWinter = ({
  temperatureDryBulb,
  temperatureWetBulb,
  temperatureDewPoint,
  relativeHumidity,
  absoluteHumidity,
  enthalpy,
  airFlowHours,
  airFlowSeconds,
  massFlow,
  realFlow,
  airDensity,
  usedPower,
  usedWater,
  process,
}) => {
  //update first points with values from position
  //

  const newPoint = 0;
  return {
    type: SET_PROCESSPOINT_WINTER,
    payload: newPoint,
  };
};*/
export const setInitialStateWinter = () => {
  return { type: SET_INITIAL_STATE };
};
export const addNewWinterProcessPoint = () => {
  return { type: ADD_NEW_WINTER_PROCESSPOINT };
};
export const changeWinterPointProcess = (processName, processID) => {
  return {
    type: CHANGE_WINTER_POINT_PROCESS,
    payload: { processName, processID },
  };
};
export const deleteWinterProcessPoint = (processID) => {
  return {
    type: DELETE_PROCESS_POINT,
    payload: processID,
  };
};
export const updateAirflowWinter = (airFlow, airFlowUnit, mixingRatio) => {
  return {
    type: UPDATE_AIRFLOW,
    payload: { airFlow, airFlowUnit, mixingRatio },
  };
};

export const updateOutdoorPointWinter = (
  temperatureDryBulb,
  temperatureWetBulb,
  temperatureDewPoint,
  relativeHumidity,
  elevation,
  airFlowHours
) => {
  //menja prvu tacku u nizu i popunjava je podacima iz project item-a
  //pozivaju se funkcije za kalkulacije parametara apsolutna vlaznost, entalpija, gustina, protok, maseni pritisak
  //kreira se novi objekat koji ce zameniti prvu tacku sa inicijalnim vrednostima

  const {
    absoluteHumidity,
    enthalpy,
    massFlow,
    realFlow,
    airDensity,
    temperatureWetBulbCalculated,
  } = calculateTableData(
    temperatureDryBulb,
    temperatureWetBulb,
    temperatureDewPoint,
    relativeHumidity,
    elevation,
    airFlowHours
  );

  const newPoint = {
    temperatureDryBulb: temperatureDryBulb,
    temperatureWetBulb: temperatureWetBulbCalculated,
    temperatureDewPoint: temperatureDewPoint,
    relativeHumidity: relativeHumidity,
    absoluteHumidity: absoluteHumidity,
    enthalpy: enthalpy,
    airFlowHours: airFlowHours,
    airFlowSeconds: airFlowHours * 60,
    massFlow: massFlow,
    realFlow: realFlow,
    airDensity: airDensity,
    usedPower: 0,
    usedWater: 0,
    process: "outdoor",
  };
  return {
    type: UPDATE_OUTDOORPOINT_WINTER,
    payload: newPoint,
  };
};

/*export const getOutdoorPointWinter = () => {
  return { type: GET_OUTDOORPOINT_WINTER };
};*/
export const updateIndoorPointWinter = (
  temperatureDryBulb,
  temperatureWetBulb,
  temperatureDewPoint,
  relativeHumidity,
  elevation,
  airFlowHours
) => {
  //menja prvu tacku u nizu i popunjava je podacima iz project item-a koji su prosledjeni kao payload
  //pozivaju se funkcije za kalkulacije parametara apsolutna vlaznost, entalpija, gustina, protok, maseni pritisak
  //kreira se novi objekat koji ce zameniti prvu tacku sa inicijalnim vrednostima
  const {
    absoluteHumidity,
    enthalpy,
    massFlow,
    realFlow,
    airDensity,
    temperatureWetBulbCalculated,
  } = calculateTableData(
    temperatureDryBulb,
    temperatureWetBulb,
    temperatureDewPoint,
    relativeHumidity,
    elevation,
    airFlowHours
  );

  const newPoint = {
    id: 1,
    temperatureDryBulb: temperatureDryBulb,
    temperatureWetBulb: temperatureWetBulbCalculated,
    temperatureDewPoint: temperatureDewPoint,
    relativeHumidity: relativeHumidity,
    absoluteHumidity: absoluteHumidity,
    enthalpy: enthalpy,
    airFlowHours: airFlowHours,
    airFlowSeconds: airFlowHours / 3600,
    massFlow: massFlow,
    realFlow: realFlow,
    airDensity: airDensity,
    usedPower: 0,
    usedWater: 0,
    process: "indoor",
  };
  return {
    type: UPDATE_INDOORPOINT_WINTER,
    payload: newPoint,
  };
};
/*export const getIndoorPointWinter = () => {
  return { type: GET_INDOORPOINT_WINTER };
};*/

export const addOrUpdateHeatingPointWinter = (
  heatingTemperature,
  elevation,
  processID
) => {
  return {
    type: ADD_OR_UPDATE_HEATINGPOINT_WINTER,
    payload: { heatingTemperature, elevation, processID },
  };
};
export const addOrUpdateCoolingPointWinter = (
  coolingTemperature,
  P,
  airFlowHours,
  airFlowSeconds,
  coolerTemperature,
  elevation,
  maxHumidityInProcess,
  processID
) => {
  return {
    type: ADD_OR_UPDATE_COOLINGPOINT_WINTER,
    payload: {
      coolingTemperature,
      P,
      airFlowHours,
      airFlowSeconds,
      coolerTemperature,
      elevation,
      maxHumidityInProcess,
      processID,
    },
  };
};
export const addOrUpdateMixingPointWinter = (elevation, processID) => {
  return {
    type: ADD_OR_UPDATE_MIXINGPOINT_WINTER,
    payload: { elevation, processID },
  };
};
export const addOrUpdateSteamHumidifyPointWinter = (
  relativeHumidity,
  elevation,
  processID
) => {
  return {
    type: ADD_OR_UPDATE_STEAMHUMIDITYPOINT_WINTER,
    payload: { relativeHumidity, elevation, processID },
  };
};

export const changeOutdoorPointWinter = (fieldName, value) => {
  return {
    type: CHANGE_OUTDOOR_POINT_WINTER,
    payload: { fieldName, value },
  };
};
export const changeIndoorPointWinter = (fieldName1, value1) => {
  return {
    type: CHANGE_INDOOR_POINT_WINTER,
    payload: { fieldName1, value1 },
  };
};

export const getArrayDataWinter = () => {
  //returns array length of current state
  return {
    type: GET_ARRAY_DATA_WINTER,
  };
};

export const updateDLLEhaPointWinter = (
  temperatureDryBulb,

  relativeHumidity,
  elevation,
  airFlowHours
) => {
  //menja prvu tacku u nizu i popunjava je podacima iz project item-a koji su prosledjeni kao payload
  //pozivaju se funkcije za kalkulacije parametara apsolutna vlaznost, entalpija, gustina, protok, maseni pritisak
  //kreira se novi objekat koji ce zameniti prvu tacku sa inicijalnim vrednostima

  const {
    absoluteHumidity,
    enthalpy,
    massFlow,
    realFlow,
    airDensity,
    temperatureWetBulbCalculated,
  } = calculateTableData(
    +temperatureDryBulb,
    0,
    0,
    +relativeHumidity,
    +elevation,
    +airFlowHours
  );
  console.log(absoluteHumidity, enthalpy, massFlow, realFlow, airDensity);

  const newPoint = {
    temperatureDryBulb: temperatureDryBulb,
    temperatureWetBulb: temperatureWetBulbCalculated,
    temperatureDewPoint: 0,
    relativeHumidity: relativeHumidity,
    absoluteHumidity: absoluteHumidity,
    enthalpy: enthalpy,
    airFlowHours: airFlowHours,
    airFlowSeconds: airFlowHours / 3600,
    massFlow: massFlow,
    realFlow: realFlow,
    airDensity: airDensity,
    usedPower: 0,
    usedWater: 0,
    process: "DLL point",
  };

  return {
    type: ADD_DLL_EHA_POINT_WINTER,
    payload: newPoint,
  };
};

export const updateDLLSupPointWinter = (
  temperatureDryBulb,

  relativeHumidity,
  elevation,
  airFlowHours
) => {
  //menja prvu tacku u nizu i popunjava je podacima iz project item-a koji su prosledjeni kao payload
  //pozivaju se funkcije za kalkulacije parametara apsolutna vlaznost, entalpija, gustina, protok, maseni pritisak
  //kreira se novi objekat koji ce zameniti prvu tacku sa inicijalnim vrednostima

  const {
    absoluteHumidity,
    enthalpy,
    massFlow,
    realFlow,
    airDensity,
    temperatureWetBulbCalculated,
  } = calculateTableData(
    +temperatureDryBulb,
    0,
    0,
    +relativeHumidity,
    +elevation,
    +airFlowHours
  );

  const newPoint = {
    temperatureDryBulb: temperatureDryBulb,
    temperatureWetBulb: temperatureWetBulbCalculated,
    temperatureDewPoint: 0,
    relativeHumidity: relativeHumidity,
    absoluteHumidity: absoluteHumidity,
    enthalpy: enthalpy,
    airFlowHours: airFlowHours,
    airFlowSeconds: airFlowHours * 60,
    massFlow: massFlow,
    realFlow: realFlow,
    airDensity: airDensity,
    usedPower: 0,
    usedWater: 0,
    process: "DLL point",
  };

  return {
    type: ADD_DLL_SUP_POINT_WINTER,
    payload: newPoint,
  };
};

export const updateHeaterSupPoint = (
  temperatureDryBulb,

  relativeHumidity,
  elevation,
  airFlowHours
) => {
  //menja prvu tacku u nizu i popunjava je podacima iz project item-a koji su prosledjeni kao payload
  //pozivaju se funkcije za kalkulacije parametara apsolutna vlaznost, entalpija, gustina, protok, maseni pritisak
  //kreira se novi objekat koji ce zameniti prvu tacku sa inicijalnim vrednostima

  const {
    absoluteHumidity,
    enthalpy,
    massFlow,
    realFlow,
    airDensity,
    temperatureWetBulbCalculated,
  } = calculateTableData(
    +temperatureDryBulb,
    0,
    0,
    +relativeHumidity,
    +elevation,
    +airFlowHours
  );

  const newPoint = {
    temperatureDryBulb: temperatureDryBulb,
    temperatureWetBulb: temperatureWetBulbCalculated,
    temperatureDewPoint: 0,
    relativeHumidity: relativeHumidity,
    absoluteHumidity: absoluteHumidity,
    enthalpy: enthalpy,
    airFlowHours: airFlowHours,
    airFlowSeconds: airFlowHours * 60,
    massFlow: massFlow,
    realFlow: realFlow,
    airDensity: airDensity,
    usedPower: 0,
    usedWater: 0,
    process: "Heater point",
  };

  return {
    type: ADD_HEATER_SUP_POINT,
    payload: newPoint,
  };
};

export const updateHeaterEhaPoint = (
  temperatureDryBulb,

  relativeHumidity,
  elevation,
  airFlowHours
) => {
  //menja prvu tacku u nizu i popunjava je podacima iz project item-a koji su prosledjeni kao payload
  //pozivaju se funkcije za kalkulacije parametara apsolutna vlaznost, entalpija, gustina, protok, maseni pritisak
  //kreira se novi objekat koji ce zameniti prvu tacku sa inicijalnim vrednostima

  const {
    absoluteHumidity,
    enthalpy,
    massFlow,
    realFlow,
    airDensity,
    temperatureWetBulbCalculated,
  } = calculateTableData(
    +temperatureDryBulb,
    0,
    0,
    +relativeHumidity,
    +elevation,
    +airFlowHours
  );
  console.log(absoluteHumidity, enthalpy, massFlow, realFlow, airDensity);

  const newPoint = {
    temperatureDryBulb: temperatureDryBulb,
    temperatureWetBulb: temperatureWetBulbCalculated,
    temperatureDewPoint: 0,
    relativeHumidity: relativeHumidity,
    absoluteHumidity: absoluteHumidity,
    enthalpy: enthalpy,
    airFlowHours: airFlowHours,
    airFlowSeconds: airFlowHours / 3600,
    massFlow: massFlow,
    realFlow: realFlow,
    airDensity: airDensity,
    usedPower: 0,
    usedWater: 0,
    process: "Heater point",
  };

  return {
    type: ADD_HEATER_EHA_POINT,
    payload: newPoint,
  };
};
